import axios from 'axios'

export interface NotificationOut {
  id: string
  type: string
  title: string
  body?: string
  data?: Record<string, unknown>
  is_read: boolean
  created_at: string
}

const API_BASE = `${import.meta.env.VITE_API_BASE_URL ?? ''}/communications/notifications`

const buildHeaders = (tenantId: string) => {
  const headers: Record<string, string> = {}
  const token = localStorage.getItem('token')
  if (tenantId) headers['X-Tenant-ID'] = tenantId
  if (token) headers['Authorization'] = `Bearer ${token}`
  return headers
}

export const listNotifications = async (tenantId: string, unreadOnly = false): Promise<NotificationOut[]> => {
  const response = await axios.get(API_BASE, {
    params: { unread_only: unreadOnly },
    headers: buildHeaders(tenantId),
  })
  return response.data
}

export const markNotificationRead = async (tenantId: string, notificationId: string): Promise<NotificationOut> => {
  const response = await axios.post(`${API_BASE}/${notificationId}/read`, null, {
    headers: buildHeaders(tenantId),
  })
  return response.data
}
